import React from "react";

interface Content {
    number: string;
    inscription: string;
    el:string;
}

const BigNumber = (props: Content) => {
  const { number, inscription, el } = props;

  return (
      <>
      <div className={`big-number ${el}`}>
        <div  className="big-number__content">
          <div className="big-number__number">
            <p>{number}</p>
          </div>
          <div  className="big-number__inscription">
            <p dangerouslySetInnerHTML={{ __html: inscription || '' }} />
          </div>
        </div>
    </div>
    </>
  )
};

export default BigNumber;
